import { visiblePages } from '../config/sidebarConfig';

/**
 * Pick a landing page based on the user's permissions.
 *
 * Walks the sidebar in display order — into the categories, since the pages now
 * live under them — and returns the first page the user can actually open.
 * Falls back to /profile when nothing matches.
 *
 * The eligibility test is the sidebar's own, not a second copy of it. This used
 * to check `permission` alone, so a user holding page:power-ai — which reaches
 * Powow Power via `anyPermission` — was landed on their profile past a page
 * they could open, and a role type gate was not considered at all.
 */
export function getDefaultRoute(permissions = [], roleType) {
  const list = Array.isArray(permissions) ? permissions : [];
  const pages = visiblePages(list, roleType);
  return pages.length ? pages[0].path : '/profile';
}

export function getStoredPermissions() {
  try {
    return JSON.parse(localStorage.getItem('permissions') || '[]');
  } catch {
    return [];
  }
}
